import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import AbhflBackgroundImage from './abhfl_new_banner.png';
import MobileBackgroundImage from './new_mobileBackgroundImage.png'; // Import the new background image for mobile view
import useDataStore from "../../store/dataStore";
import queryString from "query-string";
import FormComponent from '../FormComponent';
import PackageDetailsComponent from "./PackageDetailsComponent";

const useStyles = makeStyles((theme) => ({
  customMainContainer: {
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    [theme.breakpoints.up("sm")]: {
      backgroundImage: `url(${AbhflBackgroundImage})`, // New background image for mobile view
    },
  },
  tcAppliedContainer: {
    textAlign: "right",
    padding: "20px 20px", // Padding for the top and right sides
    position: "absolute",
    right: "0px",
    marginTop: "-3%",
    fontSize: "1%", // Adjust the font size for mobile view
    [theme.breakpoints.down("sm")]: {
      fontSize: "1%", // Adjust the font size for larger screens
       right: "6%",
       marginBottom: "84%",
       bottom: 0
    },
  },
  contentContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    [theme.breakpoints.up("sm")]: {
      flexDirection: "row",
      justifyContent: "center",
    },
  },
  packageDetailsContainer: {
    // marginBottom: 20,
    backgroundImage: `url(${MobileBackgroundImage})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundSize: "360px 276px",
    // height: "100%",
    // display: "grid",
    // gridTemplateRows: "6% 8% 3% 48% auto 13%",
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      // marginRight: 20,
      backgroundImage: "none",
    },
  },
  formContainer: {
    maxWidth: "31%",
    opacity: 0.85,
    margin: "2% 2% 2% 0%",
    [theme.breakpoints.down("sm")]: {
      margin: "10px",
      maxWidth: 380,
    },
  },
}));

const CustomMainComponent = () => {
  const classes = useStyles();
  const [parsed, setParsed] = useState(queryString.parse(window.location.search));
  const terms_condition_url = `/terms-and-conditions?utm_source=${parsed.utm_source}`;
  const packageData = useDataStore((state) => state.data);
  localStorage.setItem("source", parsed.utm_source);
  console.log("package Data ", packageData);

  console.log("parsed ", parsed);
  console.log("terms_condition_url", terms_condition_url);

  return (
    <div>
      <div className={classes.customMainContainer}>
        <div className={classes.contentContainer}>
          <div className={classes.packageDetailsContainer}>
            <PackageDetailsComponent package={packageData.packages[0]} />
          </div>
          <div className={classes.formContainer}>
            <FormComponent
              selectedPackage={packageData.packages[0]}
              baseURl = {'abhfl_home'}
              style={{ backgroundColor: '#C7222A', width: '80%', margin: '0px 20px 20px 20px', padding: '2%', borderRadius: '20px', fontSize: '1.3em' }}
            />
            <div style={{ margin: '20px 20px 20px 0px', borderRadius: '20px', backgroundColor: 'white', padding: '4%', fontSize: '0.8em'}}>
              <b>Note:</b> "The user may submit a claim for deactivation of the plan by emailing at <a href="mailto:hello@medibuddy.in">hello@medibuddy.in</a>. The refund request must be submitted within 60 days of purchase and the same shall get processed through the payment mode opted by the user."
            </div>
          </div>
        </div>
        {/* <div className={classes.tcAppliedContainer}>
          <a
            className="tc-applied-link"
            href={terms_condition_url}
            target="_blank"
            rel="noopener noreferrer"
          >
            T&C Applied
          </a>
        </div> */}
      </div>
      <div className={classes.tcAppliedContainer}>
        <a
          className="tc-applied-link"
          style={{color: 'white'}}
          href={terms_condition_url}
          target="_blank"
          rel="noopener noreferrer"
        >
          T&C Applied
        </a>
      </div>
    </div>
  );
};

export default CustomMainComponent;
